import ReactDOM from 'react-dom';
import { Modal, Popover, Typography } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useEffect, useState, useRef } from 'react';
import { Hash } from 'react-feather';
import Parameters from './Parameters'
import './index.scss';

const { Paragraph, Text } = Typography;

const showTaskForm = (props = {}) => {
  const div = document.createElement('div');
  document.body.appendChild(div);

  const destroy = () => {
    const unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  };

  const helpText = (
    <div style={{ width: 500, lineHeight: '1.6rem', whiteSpace: 'pre-wrap' }}>
      <Paragraph>
        This panel allows you to execute the <i><strong>{props.node.get('name')}</strong></i> task that you have created.
      </Paragraph>
      <Text type="secondary">
        Update the parameters using this form and click <i><strong>Run Now</strong></i> to apply the new configuration and execute the task at the earliest available time.
      </Text>
    </div>
  );

  const renderedTitle = (
    <div className="title-container">
      <Hash className="hash-icon" />
      <span>{props.node.get('name')}</span>
      <Popover
        content={helpText}
        title={props.node.get('name')}
        trigger="click"
        placement="left"
      >
        <a className="helper-icon">
          <QuestionCircleOutlined />
        </a>
      </Popover>
    </div>
  );

  const TaskFormModal = ({ destroy }) => {
    const [visible, setVisible] = useState(true);
    const intervalRef = useRef(null);

    const startPolling = (fetchAndStore) => {
      if (!intervalRef.current) {
        intervalRef.current = setInterval(async () => {
          try {
            await fetchAndStore();
          } catch (error) {
            console.error('Error during polling:', error);
          }
        }, 3000);
      }
    };

    const stopPolling = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };

    useEffect(() => {
      if (!visible) {
        destroy();
        stopPolling();
      }
    }, [visible, destroy]);

    return (
      <Modal
        maskClosable={false}
        centered={true}
        width="80%"
        visible={visible}
        footer={null}
        onCancel={() => setVisible(false)}
        afterClose={destroy}
        title={renderedTitle}
      >
        <Parameters
          destroy={destroy}
          startPolling={startPolling}
          {...props}
        />
      </Modal>
    );
  };

  ReactDOM.render(<TaskFormModal destroy={destroy} />, div);
};

export default showTaskForm;
